import { render, staticRenderFns } from "./CreateReminderModal.vue?vue&type=template&id=a6edbdb4&"
import script from "./CreateReminderModal.vue?vue&type=script&lang=js&"
export * from "./CreateReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports